import { render, staticRenderFns } from "./AsideRight.vue?vue&type=template&id=fcae21a4&"
import script from "./AsideRight.vue?vue&type=script&lang=js&"
export * from "./AsideRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports